import { useQuery } from "@tanstack/react-query";
import { API } from "utils/Helper";

const fetchHelpCenter = async () => {
  const API_URL = API || 'http://localhost:3009';
  const r = await fetch(`${API_URL}/help-center`);
  const payload = await r.json();
  if (payload && payload.success) {
    return payload.data || [];
  }
  throw new Error("Failed to fetch help center pages");
};

export const useHelpCenterQuery = () => {
  return useQuery({
    queryKey: ["helpCenter"],
    queryFn: fetchHelpCenter,
    staleTime: 10 * 60 * 1000, // Keep in cache for 10 minutes without refetching
    refetchOnWindowFocus: false,
  });
};
